"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMenuLink = exports.LogoutLink = exports.UserIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _Link = require("./Link");

var _Icons = require("./Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UserIcon = function UserIcon(_ref) {
  var firstInitial = _ref.firstInitial,
      lastInitial = _ref.lastInitial,
      restProps = _objectWithoutProperties(_ref, ["firstInitial", "lastInitial"]);

  return _react.default.createElement("div", _extends({
    className: "vs-user-icon-circle"
  }, restProps), _react.default.createElement("span", {
    className: "vs-user-icon-first"
  }, firstInitial), _react.default.createElement("span", {
    className: "vs-user-icon-last"
  }, lastInitial));
};

exports.UserIcon = UserIcon;

var LogoutLink = function LogoutLink(_ref2) {
  var onLogout = _ref2.onLogout,
      label = _ref2.label,
      restProps = _objectWithoutProperties(_ref2, ["onLogout", "label"]);

  return _react.default.createElement(_Link.Link, restProps, _react.default.createElement("a", {
    onClick: onLogout
  }, _react.default.createElement(_Link.LinkContentWrapper, {
    icon: _react.default.createElement(_Icons.LogoutIcon, null),
    label: label || 'Logout'
  })));
};

exports.LogoutLink = LogoutLink;

var UserMenuLink = function UserMenuLink(_ref3) {
  var onClicked = _ref3.onClicked,
      linkIcon = _ref3.linkIcon,
      linkLabel = _ref3.linkLabel,
      restProps = _objectWithoutProperties(_ref3, ["onClicked", "linkIcon", "linkLabel"]);

  return _react.default.createElement(_Link.Link, restProps, _react.default.createElement("a", {
    onClick: onClicked
  }, _react.default.createElement(_Link.LinkContentWrapper, {
    icon: linkIcon,
    label: linkLabel
  })));
};

exports.UserMenuLink = UserMenuLink;